import { Fragment, type ReactNode } from 'react';
import { t, type TranslationKey } from './I18n';

/**
 * A translation with React nodes in its `{0}`, `{1}`… places — a key, a link, a bold name — so a
 * sentence stays one key and each language puts the parts where its grammar wants them.
 */
export function rich(key: TranslationKey, ...parts: ReactNode[]): ReactNode {
  const pieces = t(key).split(/(\{\d+\})/);
  return pieces.map((piece, index) => {
    const slot = /^\{(\d+)\}$/.exec(piece);
    return <Fragment key={index}>{slot ? parts[Number(slot[1])] : piece}</Fragment>;
  });
}
